<template>
  <div>
    <v-row>
      <v-col cols="12">
        <yandex-map
          style="width: 100%; height: 600px;"
          :settings="map.settings"
          :coords="map.coords"
          :cluster-options="map.clusterOptions"
          show-all-markers
          :controls="map.controls"
        >
          <ymap-marker
            v-for="(point,index) in map.points"
            :key="index"
            :coords="[point.place_item.address_data.geo_lat, point.place_item.address_data.geo_lon]"
            marker-id="index"
            :hint-content="point.name"
            cluster-name="points"
            :balloon="{header: point.number, body: point.name}"
            marker-type="placemark"
            @balloonopen="bindListener(point)"
            @balloonclose="unbindListener(point)"
          >
            <div slot="balloon">
              <p>Номер точки: {{ point.number }}</p>
              <p>Наименование: {{ point.name }}</p>
              <p>Адрес: {{ point.place_item.address }}</p>
              <p>Статус: {{ dict.state[point.state] }}</p>
              <v-icon
                id="btn"
                color="primary"
                @click="$router.push('/admin/point/view?id=' + data.id)"
              >
                mdi-eye
              </v-icon>
              <v-icon color="primary">
                mdi-monitor-eye
              </v-icon>
              <v-icon color="primary">
                mdi-credit-card-marker
              </v-icon>
            </div>
          </ymap-marker>
        </yandex-map>
      </v-col>
      <v-dialog
        v-model="dialog.point.show"
        persistent
        width="700"
      >
        <point-form
          :show="dialog.point.show"
          :create="dialog.point.create"
          :change="dialog.point.change"
          :view="dialog.point.view"
          :data="dialog.point.data"
          @close="point_close"
        />
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { yandexMap, ymapMarker } from 'vue-yandex-maps'
  export default {
    name: 'Dashboard',
    components: { yandexMap, ymapMarker },
    data () {
      return {
        dict: {
          state: {
            0: 'Новый',
            1: 'Активный',
            2: 'Заблокирован',
          },
        },
        dialog: {
          point: {
            show: false,
            create: false,
            view: false,
            show: false,
            data: null
          }
        },
        map: {
          coords: [54.735147, 55.958727],
          settings: {
            apiKey: 'df228d50-f05d-46b7-b2a7-afccf3a31cb3',
            lang: 'ru_RU',
            coordorder: 'latlong',
            version: '2.1',

          },
          controls: ['geolocationControl', 'rulerControl', 'typeSelector', 'zoomControl'],
          points: [],
          clusterOptions: {
            points: {
              clusterDisableClickZoom: true,
              clusterOpenBalloonOnClick: true,
            },
          },
        },
      }
    },
    mounted: function () {
        this.axios.post('/api/point/list', {
          geo: true
        })
          .then(response => {
            this.map.points = response.data.data.filter(a => a.place_item && a.place_item.address_data)
          })
          .catch(e => {
            this.loading = false
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
    },
    methods: {
      bindListener (point) {
        document.getElementById('btn').addEventListener('click', () => { console.log('wow'); this.show_view_dialog(point) })
      },
      unbindListener (point) {
        document.getElementById('btn').removeEventListener('click', () => { this.show_view_dialog(point) })
      },
      show_view_dialog: function (data) {
        this.$router.push('/admin/point/view?id=' + data.id)
        /*
        this.dialog.point.create = false
        this.dialog.point.change = false
        this.dialog.point.view = true
        this.dialog.point.show = true
        this.dialog.point.data = data */
      },
    },
  }
</script>
